import { swCacheService } from "../hmodules/harri-main/services/sw-cache.service.js";

window.UserAPI =  new function() {
    var self = this;
    var _protected = BaseAPI.call(self);
    var HarriAcademyUrl = publicConfiguration.INTERNAL_ACADEMY;

    _protected.setApiUrl(environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.tsCoreServersBaseURL : publicConfiguration.APIServerBaseURL );

    self.getProfile = function (memberId) {
        var deferred = $q.defer();
        var apiUrl = environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? environmentsConfig.get('tsCoreServers') : environmentsConfig.get('coreReaderAPIServers');

        _protected.request(apiUrl +'profile/member/' + memberId, 'GET').then(function (res) {
            if (res && res.data && res.data.data) {
                var member = res.data.data;
                member.user_info.full_name = member.user_info.first_name + ' ' + member.user_info.last_name;

                deferred.resolve(member);
            }
        });

        return deferred.promise;
    };

    self.login = function (username, password, gCaptchaResponse) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'login', 'PUT', { username: username, password: password, 'g-recaptcha-response': gCaptchaResponse })
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data);
                }
                else {
                    deferred.reject(res.data.data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.logout = function () {
        var deferred = $q.defer();

        _protected.request("logout", "GET")
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.isSSOLogin = function (username) {
        const deferred = $q.defer();
        const params = {
            username: username
        };
        _protected.request("public/login/flow", "GET", params).then(function (res) {
            if (res?.data?.status_code === 200 && res?.data?.data?.flow === 'ENTERPRISE') {
                deferred.resolve(true);
            } else {
                deferred.resolve(false);
            }
        }, function (err) {
            deferred.reject(err);
        });
        return deferred.promise;
    };

    self.markAsInvalidToken = function (token) {
        var deferred = $q.defer();

        _protected.request("logout", "POST", {
            "refresh_token": token
        }).then(function (res) {
            deferred.resolve(res.data);
        }, function (err) {
            // we need to resolve the promise both ways
            deferred.resolve(err);
        });

        return deferred.promise;
    };

    self.loginNoRecaptcha = function (username, password, apiKey) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'login', 'PUT', { username: username, password: password, api_key: apiKey })
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data);
                }
                else {
                    deferred.reject(res.data.data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.resetPasswordByEmail = function (email, redirectURL) {
        var deferred = $q.defer();

        var payLoad = {
            username: email
        };

        if (redirectURL) {
            payLoad['return_url'] = window.location.origin + redirectURL;
        }

        _protected.request('reset_password', 'POST', payLoad)
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data);
                }
                else {
                    deferred.reject(res.data);
                }
            }, function (err) {
                deferred.reject(err.data);
            });

        return deferred.promise;
    };

    self.setNewPassword = function (code, newPassword, confirm_new_password) {
        var deferred = $q.defer();

        _protected.request('resetPasswordConfirmation', 'POST', { code: code, new_password: newPassword, confirm_new_password: confirm_new_password })
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data);
                }
                else {
                    deferred.reject(res.data);
                }
            }, function (err) {
                deferred.reject(err.data);
            });

        return deferred.promise;
    };

    self.registerNewUser = function(userModel, referrer_username, brand_id, job_id){
        var deferred = $q.defer();

        var asyncGlobalHandler = getAngularService('asyncGlobalHandler');
        var trackingSourceData = ReferralUtils.getRefererSource();
        var requestPayload = {
            "first_name": userModel.first_name,
            "last_name": userModel.last_name,
            "password": userModel.password,
            "email": userModel.email,
            "phone": userModel.phone,
            "registration_source": userModel.registration_source,
            'g-recaptcha-response': userModel['g-recaptcha-response']
        };

        if (brand_id) {
            requestPayload["brand_id"] = brand_id;
        }

        if (job_id && !brand_id) {
            requestPayload["job_id"] = job_id;
        }

        if(trackingSourceData){
          if(trackingSourceData.referrer){
            requestPayload.referrer = trackingSourceData.referrer;
          }

          if(trackingSourceData.referrer_campaign){
            requestPayload.referrer_campaign = trackingSourceData.referrer_campaign;
          }

          if(trackingSourceData.device_type){
            requestPayload.device_type = trackingSourceData.device_type;
          }
        }

        if(referrer_username){
          requestPayload.referrer_username = referrer_username;
        }

        var result = _protected.request(self.apiUrl.replace('v1', 'v2') + 'registration/basicInfo', 'PUT', requestPayload).then(function(data){
            _protected.handleResponse(data.data, deferred);
        }, function(e){
            deferred.reject(e);
        });


        asyncGlobalHandler.watchPromise(result);

        return deferred.promise;
    };

    self.registerOAuthNewUser = function(userModel){
        var deferred = $q.defer();

        var requestPayload = {
            "first_name": userModel.first_name,
            "last_name": userModel.last_name,
            "user_type": userModel.user_type || "CANDIDATE",
            "registration_mode": userModel.mode || "NORMAL"
        };

        if (userModel.placeholder_token) {
            requestPayload['placeholder_token'] = userModel['placeholder_token'];
        }

        if (userModel.currency && userModel.currency.id) {
            requestPayload['currency'] = {"id": userModel.currency.id};
        }

        if(userModel['brand']){
            requestPayload['brand'] = userModel['brand'];
        }

        var result = _protected.request(self.apiUrl + 'users/registration', 'POST', requestPayload).then(function(data){
            _protected.handleResponse(data.data, deferred);
        }, function(e){
            deferred.reject(e);
        });

        return deferred.promise;
    };

    self.updateUserDetails = async (brandId, userId, payload) => {
        const params = {
            birth_date: moment(payload.birth_date).format("YYYY-MM-DD")
        }
        const res = await _protected.request(`brands/${brandId}/candidates/${userId}/personal_info`, 'PUT', params);
        if (res?.data?.data  && res.status === 200) {
            return res.data.data;
        }
        throw res;
    };

    self.federatedRegistration = function(){
        var deferred = $q.defer();

        var requestPayload = {
            "user_type": "CANDIDATE", // We don't support EMPLOYER
        };

        var result = _protected.request(`${self.apiUrl.replace('v1', 'v2')}users/federated_registration`, 'POST', requestPayload).then((data) => {
            _protected.handleResponse(data.data, deferred);
        }, function(e){
            deferred.reject(e.data);
        });

        return deferred.promise;
    };


    self.updateCandidateDetails = function(data){
        var deferred = $q.defer();
        var result = _protected.request(self.apiUrl + 'users/registration/details', 'PUT', data).then(function(data){
            _protected.handleResponse(data.data, deferred);
        }, function(e){
            deferred.reject(e);
        });

        return deferred.promise;
    };

    self.registerNewCarriUser = function(data){
        var deferred = $q.defer();
        _protected.request(self.apiUrl + 'public/carri/brands/users/registration', 'POST', data).then(function(data){
            _protected.handleResponse(data.data, deferred);
        }, function(e){
            deferred.reject(e);
        });

        return deferred.promise;
    };

    self.emailExists = function(email){

        var deferred = $q.defer();
        _protected.uniqueRequest('registration/validateEmail', 'POST', {
            "email": email
        }).then(function(data){
            _protected.handleResponse(data.data, deferred);
        }, function(e){
            deferred.reject(e);
        });

        return deferred.promise;
    };

    self.validateUsername = function(username){

        var deferred = $q.defer();
        _protected.uniqueRequest('registration/validateUsername', 'POST', {
            'username': username
        }).then(function(data){
            _protected.handleResponse(data.data, deferred);
        }, function(e){
            deferred.reject(e);
        });

        return deferred.promise;
    };

    self.getUserPersonalInfo = function (brandId, userId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('teamlive/brands/' + brandId + '/users/' + userId + '/personal_info', 'GET').then(function (res) {
            if (res && res.data && res.data.data && res.data.status_code == 200) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getUserBenefits = function (brandId, userId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('employee_benefits', 'GET').then(function (res) {
            if (res && res.data && res.data.data && res.data.status_code == 200) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getCurrency = function () {
        var deferred = $q.defer();

        _protected.request('currencies', 'GET').then(function (res) {
            if (res && res.data && res.data.data && res.data.status_code == 200) {
                deferred.resolve(res.data.data.currencies);
            } else {
                deferred.reject(res);
            }
        }).catch(function (err) {
            console.error(err);
            deferred.reject(err);
        })

        return deferred.promise;
    };

    self.checkChangeEmailEligibility = function () {
        var deferred = $q.defer();

        _protected.request("users/me/email_change/check_eligibility", "GET")
            .then(function (res) {
                    if (res.data && res.data.status_code === 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.updateUserPersonalInfo = function (brandId, userId, payload) {
        var deferred = $q.defer();

        _protected.request("teamlive/brands/" + brandId + "/users/" + userId + "/personal_info", "PUT", payload)
            .then(function (res) {
                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    /**
     * Create new team/learner user
     * @param brandId
     * @param member/learner
     */
    self.createNewTeamScheduleMember = function (brandId, member) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request(self.apiUrl.replace('v1', 'v2') + "teamlive/brands/" + brandId + "/users", "POST", member)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.forgotPassword =  (email , gRecaptchaResponse , flow = `HARRI`) => {
        var deferred = $q.defer();

        const params = {
            username: email,
            flow,
            'g-recaptcha-response': gRecaptchaResponse
        };

        _protected.request(`users/request_reset_password`, "POST", params)
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getUserDetails = function (teamUserId) {
        var deferred = $q.defer();

        _protected.request("teamlive/users/" + teamUserId + "/personal_info", "GET")
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.updateUserInfo = function (teamUserId, data) {
        var deferred = $q.defer();
        _protected.request("teamlive/users/" + teamUserId + "/personal_info", "PUT", data)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.passwordReset = function (token, password) {
        var deferred = $q.defer();

        var params = {
            token: token,
            password: password
        };

        _protected.request("teamlive/reset_password", "POST", params)
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getUserProfileInfo = function () {
        var deferred = $q.defer();

        _protected.request("profile_details", "GET")
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.updateUserProfileInfo = function (data) {
        var deferred = $q.defer();
        _protected.request("profile_details", "PUT", data)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.radissonRegister = function (code, redirectUri) {
        var deferred = $q.defer();
        _protected.request('radisson_register', 'PUT', {
            "code": code,
            "redirect_uri": redirectUri
        }).then(function (data) {
            _protected.handleResponse(data.data, deferred);
        }, function (e) {
            deferred.reject(e);
        });

        return deferred.promise;
    };

    /**
     * Get basic user info details for a given user id
     * @param userId
     * @returns {deferred.promise|{then}|{email, first_name, last_name, phone, ...}}
     */
    self.getUserBasicDetails = function(userId) {
        var deferred = $q.defer();

        _protected.request('user_details/' + userId, 'GET')
            .then(function(res) {
                if (res && res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
            }, function(e){
                deferred.reject(e);
            });

        return deferred.promise;
    };

    self.getUserBasicMedia = function() {
        var deferred = $q.defer();

        _protected.request('user/basic_media', 'GET')
            .then(function (res) {
                if (res && res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserAppliedJobs = function (brandIds) {

        var requestPayload = {};
        requestPayload.brand_ids = brandIds || [];

        var deferred = $q.defer();
        _protected.request('user/applied_jobs', 'Post', requestPayload)
            .then(function (res) {
                if (res && res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
            }, function (e) {
                deferred.reject(e);
            });

        return deferred.promise;
    }

    //gets the current position for specified user
    self.getUserCurrentPosition = function (userId) {

        var deferred = $q.defer();

        _protected.request('user/current_position/' + userId, 'GET')
            .then(function (res) {
                if (res && res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
            }, function (e) {
                deferred.reject(e);
            });

        return deferred.promise;
    };

    //Get logged-in user Info
    var getLoggedInUserInfoAPICall = function() {
        var deferred = $q.defer();
        var params = {};
        const apiUrl = environmentsConfig.get('coreReaderAPIServers');

        if (environmentsConfig.getEnv().host !== environmentsConfig.TEAM_SCHEDULE) {
            params['include_persona'] = true;
            params['include_highest_parent'] = true;
        }

        hLoginManager.getToken().then(function(token) {
            if (token) {
                _protected.request(apiUrl +'users/info', 'GET', params)
                    .then(function (res) {
                        if (res && res.data && res.status === 200 && res.data.data) {
                            deferred.resolve(res.data.data);
                        } else {
                            deferred.reject(res);
                        }
                    }, function (e) {
                        deferred.reject(e);
                    });
            } else {
                deferred.reject();
            }
        });

        return deferred.promise;
    };

    var usersInfoRequests = [];
    self.getLoggedInUserInfo = function (userId) {

        var deferred = $q.defer();

        if(!usersInfoRequests.length) {
            getLoggedInUserInfoAPICall()
                .then(function (res) {
                    for (var i in usersInfoRequests) {
                        usersInfoRequests[i].resolve(res);
                    }

                    usersInfoRequests = [];
                }, function (err) {
                    for (var i in usersInfoRequests) {
                        usersInfoRequests[i].reject(err);
                    }

                    usersInfoRequests = [];
                });
        }

        usersInfoRequests.push(deferred);

        return deferred.promise;
    };

    //Get user policies
    var getUserPoliciesAPICall = function (groupId) {

        var deferred = $q.defer();
        var apiUrl = environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? environmentsConfig.get('tsCoreServers') : environmentsConfig.get('coreReaderAPIServers');

        _protected.request(apiUrl+ 'groups/'+groupId+'/users/policy', {
            method: 'GET',
            headers: swCacheService.getCacheHeader(`stale-while-revalidate`)
        })
            .then(function (res) {
                if (res && res.data && res.status == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res.data);
                }
            }, function (e) {
                deferred.reject(e);
            });

        return deferred.promise;
    };

    var userPoliciesRequests = [];
    self.getUserPolicies = function (groupId) {


        var deferred = $q.defer();

        if(!userPoliciesRequests.length) {
            getUserPoliciesAPICall(groupId)
                .then(function (res) {
                    for (var i in userPoliciesRequests) {
                        userPoliciesRequests[i].resolve(res);
                    }

                    userPoliciesRequests = [];
                }, function (err) {
                    for (var i in userPoliciesRequests) {
                        userPoliciesRequests[i].reject(err);
                    }

                    userPoliciesRequests = [];
                });
        }

        userPoliciesRequests.push(deferred);

        return deferred.promise;
    };

    //Get user policies
    self.getGPPolicy = function (groupId) {

        var deferred = $q.defer();

        _protected.request('users/brands/'+groupId+'/policy', 'GET')
            .then(function (res) {
                if (res && res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
            }, function (e) {
                deferred.reject(e);
            });

        return deferred.promise;
    };

    self.checkIsVerified = function (type) {
        var deferred = $q.defer();

        var params = {
            type:type
        };
        _protected.request('users/verification/check', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                console.error(err);
                deferred.reject(err);
            })

        return deferred.promise;
    };

    self.sendVerificationLink = function (type) {
        var deferred = $q.defer();

        var payLoad = {
            type: type
        };

        _protected.request('users/verification/send', 'POST', payLoad)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res.data);
                }

            })
            .catch(function (err) {
                console.error(err.data);
                deferred.reject(err.data);
            })

        return deferred.promise;
    };

    self.verifyPhonebyEmployee = function (type, code) {
        var deferred = $q.defer();

        var payLoad = {
            type: type,
            verification_code: code
        };

        _protected.request('users/verification/verify', 'POST', payLoad)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res.data);
                }

            })
            .catch(function (err) {
                console.error(err.data);
                deferred.reject(err.data);
            })

        return deferred.promise;
    };

    self.getContactDetailsHistoryByUserId = function (brandId, userId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }
        _protected.request("teamlive/brands/" + brandId + "/users/" + userId + "/secondary_info/history", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.data.secondary_info && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.secondary_info);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getContactDetailsHistoryByProspectId = function (brandId, prospectId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!prospectId) {
            throw "No prospect id";
        }
        _protected.request("brands/" + brandId + "/prospects/"+prospectId+"/users/secondary_info/history", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.data.secondary_info && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.secondary_info);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.requestVerification = function (brandId, userId, params) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request("teamlive/brands/" + brandId + "/users/" + userId + "/verification/send", "POST", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                console.error(err);
                deferred.reject(err);
            })

        return deferred.promise;
    };

    self.verifyPhonebyEmployer = function (brandId, userId, code, type) {
        var deferred = $q.defer();

        var payLoad = {
            verification_code: code,
            type: type
        };

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request("teamlive/brands/" + brandId + "/users/" + userId + "/verification/verify", "POST", payLoad)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                console.error(err);
                deferred.reject(err);
            })

        return deferred.promise;
    };

    self.resetPassword = function (brandId, userId) {
        var deferred = $q.defer();
        var endpoint = 'teamlive/brands/' + brandId + '/users/' + userId + '/password/request_reset';

        _protected.request(`${self.apiUrl.replace('v1', 'v3')}${endpoint}`, 'POST')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserLocation = function() {
        var deferred = $q.defer();

        _protected.request('user_lat_long', 'GET')
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserLocationById = function(id) {
        var deferred = $q.defer();

        _protected.request('user_locations/' + id, 'GET')
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.ConfirmDataDiscrepancy = function(params) {
        var deferred = $q.defer();

        _protected.request('users/unification_data/confirmation', 'POST', params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserSecondaryInfoByCode = function (code) {
        var defer = $q.defer();
        var params = {
            code: code
        };
        _protected.request('users/secondary_info/check', 'GET', params).then(function (res) {
            if (res && res.data && res.data.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res);
            }
        });
        return defer.promise;
    };

    self.updateUserSecondaryInfo = function(params) {
        var defer = $q.defer();
        _protected.request('users/secondary_info/activate', "POST", params).then(function (res) {
            if (res && res.data && res.data.status_code == 200) {
                defer.resolve(res);
            } else {
                defer.reject(res);
            }
        });
        return defer.promise;
    };

    self.updateBrandInfo = function(brandId, data) {
        var deferred = $q.defer();

        _protected.request('users/registration/brands/' + brandId + '/details', 'PUT', data)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserMfaStatus = function () {
        var deferred = $q.defer();

        _protected.request('users/mfa/setup/status', 'GET')
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }
    self.getAvailableMfaMethods = function () {
        var deferred = $q.defer();

        _protected.request('users/mfa_methods/available', 'GET')
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.mfa_methods);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.getAcademyLink = function () {
        var deferred = $q.defer();

        _protected.request(HarriAcademyUrl + "manager/learning_path", 'GET')
            .then(function (res) {
                    deferred.resolve(res.data.data);
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getEmployees = function (brandId, permissions) {
        var defer = $q.defer();
        var params = {};
        if (permissions) {
            params['filtered_permissions'] = permissions.join(',');
        }

        _protected.request('brands/' + brandId + '/users', 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {

                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.confirmUserPlaceholderToken = async (placeholderToken) => {
        const data = {placeholder_token: placeholderToken};
        const res = await _protected.request(`/users/placeholder_confirmation`, 'POST', data);
        if (res.data?.data && res.status === 200) {
            return res.data.data;
        }
        throw res;
    };


};
